import {parse} from "../../__snowpack__/pkg/query-string.js";
import {isEmpty, find} from "../../__snowpack__/pkg/lodash.js";
import Base64 from "../../__snowpack__/pkg/crypto-js/enc-base64.js";
import CryptoJS from "../../__snowpack__/pkg/crypto-js.js";
const getLocale = {
  id: "id-ID",
  en: "en-US",
  zh: "zh-CN"
};
export const getCurrencyCode = () => {
  const country = parse(window.localStorage.userCountryInfo);
  return isEmpty(country) ? "IDR" : country.currencyCode;
};
export const getUsercountryCode = () => {
  const country = parse(window.localStorage.userCountryInfo);
  return isEmpty(country) ? "ID" : country.countryCode;
};
export const getCurrencySymbol = (currencyCode) => {
  const countryList = !isEmpty(window.localStorage.countryList) ? JSON.parse(window.localStorage.countryList) : [];
  const isCurrencyCode = !isEmpty(currencyCode) ? currencyCode : "IDR";
  const findCountry = find(countryList, (item) => item.currencyCode === isCurrencyCode);
  return !isEmpty(findCountry) ? findCountry.currencySymbol : "Rp";
};
export const getCurrencyCodeParams = (countryCode) => {
  const countryList = !isEmpty(window.localStorage.countryList) ? JSON.parse(window.localStorage.countryList) : [];
  const findCountry = find(countryList, (item) => item.countryCode === (isEmpty(countryCode) ? "ID" : countryCode));
  return !isEmpty(findCountry) ? findCountry.currencyCode : "IDR";
};
export const formatCurrencyMoney = (price, currencyType) => {
  currencyType = currencyType || getCurrencyCode();
  try {
    return new Intl.NumberFormat(currencyType === "IDR" ? "id-ID" : "en-US", {
      style: "currency",
      currency: currencyType,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: currencyType === "IDR" ? 0 : void 0,
      maximumFractionDigits: 2
    }).format(price);
  } catch (e) {
    return getCurrencySymbol(currencyType) + new Intl.NumberFormat(currencyType === "IDR" ? "id-ID" : "en-US", {
      minimumFractionDigits: currencyType === "IDR" ? 0 : void 0,
      maximumFractionDigits: 2
    }).format(price);
  }
};
export const limitNumber = (value) => value.replace(/\D/g, "");
export const Base64Decode = (base) => Base64.parse(base).toString(CryptoJS.enc.Utf8);
